import { Link, useRouterState } from "@tanstack/react-router";
import { Home, ShoppingBag, Package, ShoppingCart, User } from "lucide-react";
import { useCart } from "@/lib/store";

export function MobileBottomNav() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const { count } = useCart();

  // Do not render bottom navbar inside admin portal or auth routes
  if (pathname.startsWith("/admin") || pathname.startsWith("/auth")) {
    return null;
  }

  const tabs = [
    { to: "/", label: "Home", icon: Home, exact: true },
    { to: "/shop", label: "Shop", icon: ShoppingBag },
    { to: "/account/orders", label: "Orders", icon: Package },
    { to: "/cart", label: "Cart", icon: ShoppingCart, badge: count },
    { to: "/account", label: "Account", icon: User },
  ];

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[999] lg:hidden bg-primary border-t border-gold/20 px-2 py-1.5 shadow-[0_-8px_30px_rgba(0,0,0,0.3)]">
      <div className="flex items-center justify-around max-w-md mx-auto">
        {tabs.map((tab) => {
          const isActive = (() => {
            if (tab.to === "/") return pathname === "/";
            if (tab.to === "/account") return pathname === "/account" || (pathname.startsWith("/account") && !pathname.startsWith("/account/orders"));
            return pathname.startsWith(tab.to);
          })();

          return (
            <Link
              key={tab.to}
              to={tab.to}
              className={`relative flex flex-col items-center justify-center w-16 py-1 transition-all ${
                isActive ? "text-gold" : "text-cream/60 hover:text-cream"
              }`}
            >
              <div className="relative">
                <tab.icon className={`h-5 w-5 transition-transform ${isActive ? "scale-110" : ""}`} strokeWidth={isActive ? 2 : 1.6} />
                {!!tab.badge && tab.badge > 0 && (
                  <span className="absolute -top-1.5 -right-2 bg-gold text-primary font-bold text-[0.6rem] h-4 min-w-[1rem] px-1 rounded-full grid place-items-center shadow-sm">
                    {tab.badge}
                  </span>
                )}
              </div>
              <span className={`text-[0.62rem] font-medium tracking-tight mt-1 ${isActive ? "font-semibold text-gold" : ""}`}>
                {tab.label}
              </span>
              {isActive && (
                <span className="absolute -bottom-0.5 h-1 w-5 rounded-full bg-gold animate-in fade-in duration-300" />
              )}
            </Link>
          );
        })}
      </div>
    </div>
  );
}
